export default {"src":"/_next/static/media/clock.952f5f05.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};